<template>
	<v-container fluid>
		<v-row justify="center">
			<v-col cols="8">
				<v-form v-if="display == 'form'"
					ref="f"
					v-model="validForm">
					<v-row >
						<v-col cols="2">
							<v-img
								src="img/survey-1.png"
								max-height="100"
								contain
							>
							</v-img>
						</v-col>
						<v-col class="headline py-12" cols="10" >
							{{ name }}
						</v-col>
						<v-col cols="12">
							<span v-html="description"></span>
						</v-col>
						<v-col cols="12" v-for="(question, i) in questions" :key="question.num">
							<span class="subtitle-1">
								{{ question.num }}.
								{{ question.text }}
							</span>
							<template v-if="question.type == 'rating'">
								<v-row class="mt-4" >
									<v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
										1 звезда - совсем неудобно
										<br>
										5 звезд - очень удобно
									</v-col>
									<v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp" align-self="center">
										Совсем неудобно
									</v-col>
									<v-col cols="6">
										<v-rating
											hover
											large
											halfIncrements
											style="white-space: nowrap;"
											v-model="answers[i]">
										</v-rating>
									</v-col>
									<v-col cols="3" v-if="$vuetify.breakpoint.mdAndUp" align-self="center">
										Очень удобно
									</v-col>
								</v-row>
							</template>
							<template v-else-if="question.type == 'text'">
								<v-textarea
									auto-grow
									:rules="question.rules"
									v-model="answers[i]"
								>
								</v-textarea>
							</template>
						</v-col>

						<v-col cols="12">
							<v-btn
								color="primary"
								:disabled="!valid"
								@click="send">
								Отправить
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
				<v-row  v-else-if="display == 'thankyou'">
					<v-col cols="2">
						<v-img
							src="img/survey-1.png"
							max-height="100"
							contain
						>
						</v-img>
					</v-col>
					<v-col class="headline py-12" cols="10" >
						Спасибо!
					</v-col>
				</v-row>
				<v-row  v-else-if="display == 'forbidden'">
					<v-col cols="2">
						<v-img
							src="img/survey-1.png"
							max-height="100"
							contain
						>
						</v-img>
					</v-col>
					<v-col class="headline py-12" cols="10" >
						{{ name }}
					</v-col>
					<v-col cols="12">
						{{ forbiddenMessage }}
					</v-col>
				</v-row>
				<v-row  v-else></v-row>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import {api} from '../../lib/api'

export default {
	data: () => ({
		id: 0,
		link: '',
		name: '',
		description: '',
		open: 1,
		onlyRegistered: 0,
		userAnswered: 0,
		questions: [],
		answers: [],
		validForm: false,
		display: 'forbidden',
		forbiddenMessage: ''
	}),
	computed: {
		valid () {
			// данная проверка нужна, т.к. v-rating не распознается формой и rules на него не работают
			for (let i = 0; i < this.answers.length; i++) {
				if (this.questions[i].type == 'rating'
					&& +this.questions[i].required
					&& !this.answers[i]
				) {
					return false
				}
			}
			return this.validForm
		},
	},
	mounted () {
		this.link = this.$route.params.link
		this.load()
	},
	methods: {
		send () {
			var path

			if (this.$store.getters.loggedIn) path = 'surveys/collect_answers'
			else path = 'surveys/collect_answers_anonymous'

			api.post(path, {
				id: this.id,
				answers: this.answers
			})
			.then(response => {
				this.display = 'thankyou'
			}, error => {})
		},
		load () {
			var path

			if (this.$store.getters.loggedIn) path = 'surveys/get_entry'
			else path = 'surveys/get_entry_anonymous'

			api.post(path, {
				link: this.link,
			})
			.then(response => {
				this.id = response.data.id
				this.name = response.data.name
				this.description = response.data.description
				this.open = +response.data.open
				this.onlyRegistered = +response.data.onlyRegistered
				this.userAnswered = +response.data.userAnswered
				this.questions = response.data.questions

				if (!this.open) {
					this.display = 'forbidden'
					this.forbiddenMessage = 'Данный опрос закрыт'
				}
				else if (this.userAnswered) {
					this.display = 'forbidden'
					this.forbiddenMessage = 'Вы уже ответили на данный опрос'
				}
				else if (this.onlyRegistered && !this.$store.getters.loggedIn) {
					this.display = 'forbidden'
					this.forbiddenMessage = 'Опрос доступен только зарегистрированным пользователям'
				}
				else {
					this.display = 'form'
				}

				this.questions.forEach(question => {
					if (question.type == 'text') {
						this.answers.push('')
					}
					else {
						this.answers.push(0)
					}

					question.rules = []
					if (+question.required) {
						if (question.type == 'text') {
							question.rules.push(
								v => v.length > 0 || 'Это обязательный вопрос'
							)
						}
					}
				})
			}, error => {})
		}
	},
}
</script>
